export const VNQUERYPARAMS_SET_PRODUCT_TYPE_SELECTED = 'VNQUERYPARAMS_SET_PRODUCT_TYPE_SELECTED'
export const VNQUERYPARAMS_SET_SERVICE_TYPE_SELECTED = 'VNQUERYPARAMS_SET_SERVICE_TYPE_SELECTED'
